import _ from 'lodash';

import {
  ManualContactField,
  MANUAL_CONTACT_PHONE_FIELDS,
} from '../../AppraisalOrderContactsCard.constants';

import { REACHABILITY_ERROR_MESSAGE } from './ManualContactForm.constants';

export const getManualContactReachabilityErrors = ({ values, fields }) => {
  const reachabilityFields = [ManualContactField.EMAIL, ...MANUAL_CONTACT_PHONE_FIELDS];
  const isReachable = reachabilityFields.some(field => !!_.trim(values[field]));

  if (isReachable) {
    return {};
  }

  const errorField = fields.includes(ManualContactField.CELL_PHONE)
    ? ManualContactField.CELL_PHONE
    : ManualContactField.EMAIL;

  return { [errorField]: REACHABILITY_ERROR_MESSAGE };
};

export const getManualContactFormHint = role =>
  `${role} for this appraisal order only. Not added to the loan's contacts, borrowers or Agent and Seller.`;
